import { inject, reactive } from 'vue';
import { ServiceContext, DefaultContext } from './ServiceContext';
import { getServiceInContext } from './getServiceInContext';
export function useService(Service, options) {
    const ctx = inject(ServiceContext, DefaultContext);
    const service = getServiceInContext(Service, ctx, options);
    return reactive(service);
}
